import React from 'react';
import './Pages.css';

const Setting = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Settings</h1>
        <p>System configuration</p>
      </div>
      <div className="page-content">
        <p>Settings content goes here...</p>
      </div>
    </div>
  );
};

export default Setting;